import React from 'react';
import { cn } from '@/shared/lib/utils';

type DraftBadgeProps = {
  hasChanges: boolean;
  className?: string;
  label?: string;
};

export const DraftBadge: React.FC<DraftBadgeProps> = ({
  hasChanges,
  className,
  label = 'Non sauvegardé',
}) => {
  if (!hasChanges) {
    return null;
  }

  return (
    <span
      className={cn(
        'text-orange-800 text-xs font-medium',
        className
      )}
    >
      {label}
    </span>
  );
};
